/* edition.zb: Lightbox für Produktgalerien.
   Bedient zwei Quellen:
   1) die nahtlose Buchgalerie (statische Bindung, Quellen aus data-full, 2400px)
   2) Horizons Grid-Galerie der Varianten-Produkte (Event-Delegation am Dokument,
      weil media-gallery.js die Galerie beim Variantenwechsel komplett ersetzt;
      Horizons eigener Zoom-Button ist dort per edzb.css ausgeblendet)
   3) die Pressefotos der Presseseite (blocks/edzb-pressefoto.liquid) — dort
      zusätzlich mit Leiste für Bildunterschrift + Download-Button. Den
      Download selbst erledigt der Handler im Block edzb-pressefotos
      (Event-Delegation auf a[data-edzb-download], gilt auch im Dialog).
   Klick aufs Bild öffnet ein Vollbild-<dialog>; Blättern per Pfeil/Tasten.
   Schlankes Vanilla-JS, keine Fremd-Library. */
(() => {
  // Die Presseseite bindet das Skript je Bereichs-Block ein → nur einmal ausführen
  if (window.edzbLightboxLoaded) return;
  window.edzbLightboxLoaded = true;

  let dialog = null;
  let dimg = null;
  let bar = null;
  let sources = [];
  let alts = [];
  let details = [];
  let index = 0;

  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'edzb-lightbox';
    dialog.innerHTML =
      '<button type="button" class="edzb-lightbox__close" aria-label="Schließen">×</button>' +
      '<button type="button" class="edzb-lightbox__prev" aria-label="Vorheriges Bild">‹</button>' +
      '<img class="edzb-lightbox__img" alt="">' +
      '<button type="button" class="edzb-lightbox__next" aria-label="Nächstes Bild">›</button>' +
      '<div class="edzb-lightbox__bar">' +
      '<p class="edzb-lightbox__caption"></p>' +
      '<div class="edzb-lightbox__actions">' +
      '<a class="button edzb-lightbox__download" href=""></a>' +
      '<span class="edzb-lightbox__meta"></span>' +
      '</div></div>';
    document.body.appendChild(dialog);

    dimg = dialog.querySelector('.edzb-lightbox__img');
    bar = dialog.querySelector('.edzb-lightbox__bar');
    dialog
      .querySelector('.edzb-lightbox__close')
      .addEventListener('click', () => dialog.close());
    dialog
      .querySelector('.edzb-lightbox__prev')
      .addEventListener('click', () => show(index - 1));
    dialog
      .querySelector('.edzb-lightbox__next')
      .addEventListener('click', () => show(index + 1));

    // Klick auf den dunklen Rand schließt
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });

    document.addEventListener('keydown', (e) => {
      if (!dialog.open) return;
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
  }

  function show(i) {
    index = (i + sources.length) % sources.length;
    dimg.src = sources[index];
    dimg.alt = alts[index];

    const d = details[index];
    dialog.setAttribute('data-details', d ? 'true' : 'false');
    if (!d) return;
    bar.querySelector('.edzb-lightbox__caption').textContent = d.caption;
    bar.querySelector('.edzb-lightbox__meta').textContent = d.meta;
    const link = bar.querySelector('.edzb-lightbox__download');
    link.hidden = !d.href;
    if (d.href) {
      link.href = d.href;
      link.setAttribute('data-edzb-download', d.filename);
      link.setAttribute('download', d.filename);
      link.innerHTML = d.labelHtml;
    }
  }

  function open(newSources, newAlts, startIndex, newDetails = []) {
    if (newSources.length === 0) return;
    ensureDialog();
    sources = newSources;
    alts = newAlts;
    details = newDetails;
    dialog.setAttribute('data-single', sources.length < 2 ? 'true' : 'false');
    show(startIndex);
    dialog.showModal();
  }

  /* 1) Nahtlose Buchgalerie: DOM ist statisch, Bindung einmalig. */
  document.querySelectorAll('.edzb-book-gallery').forEach((gallery) => {
    const items = [...gallery.querySelectorAll('.edzb-book-gallery__item')];
    const srcs = items
      .map((it) => it.getAttribute('data-full'))
      .filter(Boolean);
    if (srcs.length === 0) return;

    const itemAlts = items.map((it) => {
      const img = it.querySelector('img');
      return img ? img.getAttribute('alt') || '' : '';
    });

    items.forEach((it, i) => {
      const img = it.querySelector('img');
      if (!img) return;
      img.style.cursor = 'zoom-in';
      it.addEventListener('click', () => open(srcs, itemAlts, i));
    });
  });

  /* 2) Grid-Galerie: Quellen erst beim Klick aus dem aktuellen DOM lesen —
     so stimmen sie auch nach einem Variantenwechsel. Volle Auflösung durch
     Umschreiben des width-Parameters der Shopify-CDN-URL. */
  function fullSrc(img) {
    if (!img || !img.src) return null;
    try {
      const u = new URL(img.currentSrc || img.src, window.location.href);
      u.searchParams.set('width', '2400');
      return u.href;
    } catch {
      return img.src;
    }
  }

  document.addEventListener('click', (e) => {
    if (!(e.target instanceof Element)) return;
    const item = e.target.closest(
      '.media-gallery__grid .product-media-container--image'
    );
    if (!item) return;
    const grid = item.closest('.media-gallery__grid');
    const items = [
      ...grid.querySelectorAll('.product-media-container--image'),
    ];

    const srcs = [];
    const itemAlts = [];
    let start = 0;
    items.forEach((it) => {
      const img = it.querySelector('img');
      const src = fullSrc(img);
      if (!src) return;
      if (it === item) start = srcs.length;
      srcs.push(src);
      itemAlts.push(img.getAttribute('alt') || '');
    });
    open(srcs, itemAlts, start);
  });

  /* 3) Pressefotos: alle Fotos der Seite bilden eine Blätter-Folge (über
     die Bereiche hinweg); Unterschrift + Download aus dem DOM der Kachel. */
  document.addEventListener('click', (e) => {
    if (!(e.target instanceof Element)) return;
    const zoom = e.target.closest('.edzb-pressefoto__zoom');
    if (!zoom) return;
    const figures = [...document.querySelectorAll('.edzb-pressefoto')].filter(
      (f) => f.querySelector('.edzb-pressefoto__zoom')
    );

    const srcs = [];
    const itemAlts = [];
    const itemDetails = [];
    let start = 0;
    figures.forEach((fig) => {
      const button = fig.querySelector('.edzb-pressefoto__zoom');
      const img = button.querySelector('img');
      const link = fig.querySelector('a[data-edzb-download]');
      if (button === zoom) start = srcs.length;
      srcs.push(button.getAttribute('data-full'));
      itemAlts.push(img ? img.getAttribute('alt') || '' : '');
      itemDetails.push({
        caption: fig.querySelector('.edzb-pressefoto__caption')?.textContent.trim() || '',
        meta: fig.querySelector('.edzb-pressefoto__meta')?.textContent.trim() || '',
        href: link ? link.getAttribute('href') : '',
        filename: link ? link.getAttribute('data-edzb-download') : '',
        labelHtml: link ? link.innerHTML : '',
      });
    });
    open(srcs, itemAlts, start, itemDetails);
  });
})();
